import type { DocumentNode, OperationDefinitionNode } from 'graphql';

export default function getOperationName(doc: DocumentNode): string | null {
  const defenitions = doc?.definitions?.filter(
    definition => definition.kind === 'OperationDefinition' && definition.name
  ) as OperationDefinitionNode[];

  return defenitions?.map((x: OperationDefinitionNode) => x?.name?.value)[0] || null;
}
